import PartnerWithKeyzy from "./PartnerWithKeyzy";

export default PartnerWithKeyzy;
